<template>
  <app-card>
    <v-form v-model="formValidate">
      <v-container :class="{ 'pa-0': $vuetify.breakpoint.xsOnly }">
        <v-row>
          <v-col cols="12">
            การแสดงข้อมูล
            <v-radio-group
              v-model="form.FileType"
              class="ma-0"
              row
              hide-details="auto"
            >
              <v-radio label="Excel" value="excel" />
              <v-radio label="PDF" value="pdf" />
            </v-radio-group>
          </v-col>
        </v-row>

        <v-row align="center">
          <v-col cols="auto">
            <v-btn @click="onSearch" color="primary darken-2" depressed large>
              แสดงข้อมูล
            </v-btn>
          </v-col>
          <v-col></v-col>
        </v-row>
      </v-container>
    </v-form>
  </app-card>
</template>

<script>
export default {
  props: {
    page: {
      type: Number,
      default: 1
    }
  },

  data() {
    return {
      formValidate: null,
      form: {
        FileType: 'excel',
        store: 'leave/reportLeaveRelaxStat'
      },
      empTypeDropdown: [],
      organizationDropdown01: [],
      organizationDropdown02: [],
      organizationDropdown03: [],
      organizationDropdown04: [],
      loadingDropdown01: false,
      loadingDropdown02: false,
      loadingDropdown03: false,
      loadingDropdown04: false,
      startDateMenu: false,
      finishDateMenu: false
    }
  },

  watch: {
    $route() {
      this.setForm()
    },

    form: {
      handler(newVal) {
        for (let key in newVal) {
          if (newVal[key] === null || newVal[key] === undefined) {
            this.form[key] = ''
          }
        }
      },
      deep: true
    }
  },

  async mounted() {
    await this.setForm()
  },

  methods: {
    async setForm() {
      this.form = { ...this.form, ...this.$route.query }
    },

    onSearch() {
      this.form.EmployeeID = this.$guid

      this.$router.replace({ query: this.form }).catch(() => {
        console.log('same page, same result')
      })
      this.$emit('search', this.form)
    }
  }
}
</script>

<style lang="scss" scoped></style>
